import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "49",
  height: "48",
  viewBox: "0 0 49 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<rect x=\"0.666504\" width=\"48\" height=\"48\" fill=\"white\"></rect><rect x=\"6.6665\" y=\"8\" width=\"36\" height=\"32\" rx=\"2\" fill=\"#EAECF0\"></rect><path d=\"M24.6665 12.1547L34.9248 18.0774V29.9226L24.6665 35.8453L14.4082 29.9226L14.4082 18.0774L24.6665 12.1547Z\" fill=\"white\" stroke=\"#475467\" stroke-width=\"2\"></path><line x1=\"23.6665\" y1=\"27\" x2=\"23.6665\" y2=\"20\" stroke=\"#475467\" stroke-width=\"2\" stroke-linecap=\"round\"></line><line x1=\"23.6665\" y1=\"27\" x2=\"26.6665\" y2=\"27\" stroke=\"#475467\" stroke-width=\"2\" stroke-linecap=\"round\"></line>", 5)
const _hoisted_7 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'LogoIcon',
  props: {
  fillColor: {
    type: String,
    required: false,
    default: 'white',
  },
  strokeColor: {
    type: String,
    required: false,
    default: 'white',
  },
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_7))
}
}

})